const actionTypes = {
  SET_SEND_CART_TYPE: 'sendCartDestinationSetSendCartType',

  SET_DESTINATION_DETAIL_LIST: 'setDestinationDetailList',
  REMOVE_DESTINATION_DETAIL_LIST: 'removeDestinationDetailList',

  SET_CLIENT_LIST: 'setSendCartClientList',
  SELECT_CLIENT: 'selectSendCartClient',

  SET_RESPONSIBLE_PERSON_LIST: 'setResonsiblePersonList',
  SELECT_RESPONSIBLE_PERSON: 'selectSendCartResonsiblePerson',

  SET_DESTINATION_FOLDER_TREE: 'setSendCartDestinationFolderTree',
  REMOVE_DESTINATION_FOLDER_TREE: 'removeSendCartDestinationFolderTree',
  SELECT_DESTINATION_FOLDER: 'selectSendCartDestinationFolder',

  SET_ERROR: 'setSendCartDestinatinoSelectionError',
}

export default actionTypes
